module.exports = __webpack_public_path__ + "img/ppt.9edc9d11.png";